import { useTranslation as useI18nextTranslation } from 'react-i18next';

// Hook personalizat pentru traduceri
export function useTranslation() {
  return useI18nextTranslation();
}

// Tipuri pentru cheile de traducere (opțional - pentru autocomplete IDE)
export type TranslationKey =
  // General keys (formerly common)
  | 'general.save'
  | 'general.cancel'
  | 'general.delete'
  | 'general.edit'
  | 'general.add'
  | 'general.search'
  | 'general.loading'
  | 'general.error'
  | 'general.success'
  | 'general.account'
  | 'general.uploading'
  | 'general.uploadingDescription'
  | 'general.imageUploaded'
  | 'general.tryAgain'

  // Admin sidebar keys (formerly sidebar)
  | 'admin.sidebar.dashboard'
  | 'admin.sidebar.homeSections'
  | 'admin.sidebar.staticPages'
  | 'admin.sidebar.appointments'
  | 'admin.sidebar.services'
  | 'admin.sidebar.patients'
  | 'admin.sidebar.staff'
  | 'admin.sidebar.blog'
  | 'admin.sidebar.gallery'
  | 'admin.sidebar.banners'
  | 'admin.sidebar.hero'
  | 'admin.sidebar.imageUploader'
  | 'admin.sidebar.aiSettings'
  | 'admin.sidebar.settings'
  | 'admin.sidebar.appConfiguration'

  // Admin dashboard keys (formerly dashboard)
  | 'admin.dashboard.title'
  | 'admin.dashboard.welcome'
  | 'admin.dashboard.stats.todayAppointments'
  | 'admin.dashboard.stats.pendingAppointments'
  | 'admin.dashboard.stats.completedAppointments'
  | 'admin.dashboard.stats.canceledAppointments'

  // Admin header keys
  | 'admin.header.commentsToApprove'
  | 'admin.header.testimonialsToApprove'
  | 'admin.header.logout'

  // Admin blog keys
  | 'admin.blog.comments'
  | 'admin.blog.pendingComments'
  | 'admin.blog.pendingCommentsCount'

  // Admin blog comments keys
  | 'admin.blogComments.title'
  | 'admin.blogComments.subtitle'
  | 'admin.blogComments.searchPlaceholder'

  // Patients keys
  | 'patients.title'
  | 'patients.subtitle'
  | 'patients.addNew'
  | 'patients.searchPlaceholder'
  | 'patients.filterByStatus'
  | 'patients.all'
  | 'patients.active'
  | 'patients.inactive'

  // Editor keys
  | 'editor.toolbar.insert'
  | 'editor.toolbar.format'
  | 'editor.toolbar.align'
  | 'editor.toolbar.list'
  | 'editor.toolbar.link'
  | 'editor.toolbar.image'
  | 'editor.toolbar.table'
  | 'editor.toolbar.code'
  | 'editor.toolbar.quote'
  | 'editor.toolbar.heading'
  | 'editor.toolbar.paragraph'
  | 'editor.toolbar.bold'
  | 'editor.toolbar.italic'
  | 'editor.toolbar.underline'
  | 'editor.toolbar.strikethrough'
  | 'editor.toolbar.subscript'
  | 'editor.toolbar.superscript'
  | 'editor.toolbar.highlight'
  | 'editor.toolbar.clear'
  | 'editor.toolbar.undo'
  | 'editor.toolbar.redo'
  | 'editor.toolbar.indent'
  | 'editor.toolbar.outdent'
  | 'editor.toolbar.leftAlign'
  | 'editor.toolbar.centerAlign'
  | 'editor.toolbar.rightAlign'
  | 'editor.toolbar.justifyAlign'
  | 'editor.toolbar.numberedList'
  | 'editor.toolbar.bulletList'
  | 'editor.toolbar.checkList'
  | 'editor.toolbar.horizontalRule'
  | 'editor.toolbar.pageBreak'
  | 'editor.toolbar.gif'
  | 'editor.toolbar.diagram'
  | 'editor.toolbar.poll'
  | 'editor.toolbar.columns'
  | 'editor.toolbar.equation'
  | 'editor.toolbar.sticky'
  | 'editor.toolbar.collapsible'
  | 'editor.toolbar.googleMaps'
  | 'editor.googleMaps.title'
  | 'editor.googleMaps.iframeCode'
  | 'editor.googleMaps.iframeCodePlaceholder'
  | 'editor.googleMaps.fullscreen'
  | 'editor.googleMaps.width'
  | 'editor.googleMaps.height'
  | 'editor.googleMaps.widthUnit'
  | 'editor.googleMaps.heightUnit'
  | 'editor.googleMaps.help.title'
  | 'editor.googleMaps.help.step1'
  | 'editor.googleMaps.help.step2'
  | 'editor.googleMaps.help.step3'
  | 'editor.googleMaps.help.example'
  | 'editor.googleMaps.help.dimensions'
  | 'editor.googleMaps.validation.required'
  | 'editor.googleMaps.validation.invalid'

  // Validation keys
  | 'validation.required'
  | 'validation.email'
  | 'validation.phone'
  | 'validation.minLength'
  | 'validation.maxLength';
